{
  "dismiss": "Revocare"
}